import { JDNativeToast } from '@jdreact/jdreact-core-lib';
import isAndroid from './isAndroid';
import isWeb from './isWeb';

const toastTime = isWeb
    ? 2
    : isAndroid
        ? 2000
        : 2;
const warn = text => JDNativeToast.show(text, toastTime, 1);

export default warn;
